export default (id, goal) => {
    if (typeof window.ym !== 'function') {
        return console.warn('[reachGoal]: window.ym is not a function');
    }

    window.ym(
        id, 'reachGoal', goal,
    );
    return true;
};